module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.menus), function(each, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(each.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(each.message))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(each.gender))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getOptionsText(each.options)))]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "title": "Edit",
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.editMenu(index)
        }
      }
    })])])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Message")]), _vm._v(" "), _c('th', [_vm._v("Gender")]), _vm._v(" "), _c('th', [_vm._v("Options")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-63416cd3","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/all.vue
// module id = gA8K
// module chunks = 1